$(document).ready(function() {
	// Check the availability of touch events
	$.touchEventsEnabled = ('ontouchstart' in window)
		|| (navigator.maxTouchPoints > 0)
		|| (navigator.msMaxTouchPoints > 0);

	// Blocks text selection
	$('a, control, label').on('selectstart',function() {return false;});

	// Start spinner before unload page (click link or reload page)
	$(window).on('beforeunload', function() {
		if ($.spinner.timer === undefined) {
			$.spinner.start(500);
		}
	});

	// Start spinner after click link and double click checker
	$('header a').click(function() {
		if ($.spinner.timer === undefined) {
			$.spinner.start(500);
		}
		else {
			return false;
		}
	});

	$('a, input[type=submit]').click(function() {
		if (typeof navigator === 'object' && typeof navigator.vibrate === 'function') {
			navigator.vibrate(35);
		}
	});
});